import { createContext, useContext } from 'react'

import { PLPFacetsContextValue } from './types'

export const PLPFacetsContext = createContext<PLPFacetsContextValue | undefined>(undefined)

export function usePLPFacetsContext() {
    const context = useContext(PLPFacetsContext)

    if (!context) {
        throw new Error('usePLPFacetsContext must be used within a PLPFacetsProvider')
    }
    return context
}
